var render, staticRenderFns
import script from "./order-manual.vue?vue&type=script&lang=js"
export * from "./order-manual.vue?vue&type=script&lang=js"
import style0 from "./order-manual.vue?vue&type=style&index=0&id=50431098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50431098",
  null
  
)

export default component.exports